// https://vuex.vuejs.org/en/actions.html
import { API } from 'aws-amplify'
import { ErrorMessageHelper } from '../../../errorMessageHelper'

export default {
  retrieveTempsForADay (context, params) {
    context.commit('tempsRetrieveState', 'in-progress')
    return API.get('worktools', '/temps/saisie/' + params.day, {}).then(response => {
      context.commit('tempsRetrieveState', 'ok')
      context.commit('tempsRetrieveRecords', response)
    }).catch(error => {
      context.commit('tempsRetrieveState', 'error')
      ErrorMessageHelper(context, 'Impossible de lister temps sur la journée.')
      return Promise.reject(error)
    })
  },
  retrieveTempsForMonth (context, params) {
    context.commit('tempsRetrieveState', 'in-progress')
    return API.get('worktools', '/temps/synthese/' + params.month, {}).then(response => {
      context.commit('tempsRetrieveState', 'ok')
      context.commit('tempsRetrieveRecords', response)
    }).catch(error => {
      context.commit('tempsRetrieveState', 'error')
      ErrorMessageHelper(context, 'Impossible de synthétiser le mois.')
      return Promise.reject(error)
    })
  },
  savePeriodeOfDayForAClientDossier (context, params) {
    return API.put('worktools', '/temps/saisie/' + params.day + '/clients/' + params.clientId + '/dossiers/' + params.dossierId + '/plages/' + params.plageId, {
      body: {
        debut: params.debut,
        fin: params.fin,
        description: params.description,
        tarifHoraire: params.tarifHoraire ? params.tarifHoraire : null
      }
    }).catch(error => {
      ErrorMessageHelper(context, 'Impossible d\'enregistrer la ligne de temps.')
      return Promise.reject(error)
    })
  },
  removePeriodeOfDayForAClientDossier (context, params) {
    return API.del('worktools', '/temps/saisie/' + params.day + '/clients/' + params.clientId + '/dossiers/' + params.dossierId + '/plages/' + params.plageId, {})
      .catch(error => {
        ErrorMessageHelper(context, 'Impossible de supprimer la ligne de temps.')
        return Promise.reject(error)
      })
  },
  makeExcelExportMois (context, params) {
    context.commit('downloadExcelState', 'in-progress')
    return API.get('worktools', '/temps/export/mois/' + params.mois + '/clients/' + params.clientId, {})
      .catch(error => {
        ErrorMessageHelper(context, 'Impossible de générer le fichier excel.')
        context.commit('downloadExcelState', 'ko')
        return Promise.reject(error)
      }).then(result => {
        let a = document.createElement('a')
        a.href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;base64;' + result.excel
        a.download = params.fileName + '.xlsx'
        a.click()
        context.commit('downloadExcelState', 'ok')
        return result
      })
  }
}
